export default {
  GET_USERS(state) {
    return state.users
  },
  GET_ONE_USER({ single_user }) {
    // const { permission, ...rest } = single_user
    return single_user
  },
  GET_ROLES({ roles }) {
    return roles.results
  },
  GET_USER_PERMISSIONS({ permissions }) {
    return permissions
  },
}
